import React from 'react';
import './Footer.css';
import logo from '../campus-life-black.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src={logo} alt="logo" className="footer-logo-img" />
          <span className="footer-logo-text">Campus Life Assistant</span>
        </div>
        <div className="footer-center">
          문의 | kde9811@gmail.com
        </div>
        <div className="footer-right">
          © 2026 Campus Life Assistant. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;